import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeDeAt from '@angular/common/locales/de-AT';
import localeDe from '@angular/common/locales/de';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { combineLatest, firstValueFrom, Observable, Subject } from 'rxjs';

export class TranslationsLoader implements TranslateLoader {
	constructor(private http: HttpClient) {}

	getTranslation(langCountry: string): Observable<any> {
		langCountry = langCountry?.toLowerCase() ?? 'en';

		if (langCountry === 'de') {
			registerLocaleData(localeDeAt);
			registerLocaleData(localeDe);
		}
		const subject = new Subject();
		combineLatest([
			this.http.get('/assets/i18n/' + langCountry + '.json?cb=' + Date.now()),
			this.http.get('/assets/i18n/' + langCountry + '-general.json?cb=' + Date.now()),
		]).subscribe({
			next: (arr: Array<any>) => {
				let object = {};
				Object.keys(arr).forEach((objKey: any) => {
					const array = arr[objKey];
					Object.keys(array).forEach((key: any) => {
						// checks if translation key is duplicated
						if (object.hasOwnProperty(key)) {
							// adds the translation from the general file
							(object as any)[key] = Object.assign((object as any)[key], array[key]);
						} else {
							object = Object.assign(object, { [key]: array[key] });
						}
					});
				});
				subject.next(object);
				subject.complete();
			},
		});
		return subject.asObservable();
	}
}

/**
 * We are now using this as an app initializer in the app.module.ts
 * This function is called before the app is initialized and ensures that the translations are loaded!
 * @param translate
 */
export function initializeTranslations(translate: TranslateService): () => Promise<any> {
	return () => {
		const acceptableLanguages = ['en', 'de'];
		let browserLang = translate.getBrowserLang() || 'en';
		if (browserLang.includes('-')) {
			browserLang = browserLang.split('-')[0];
		}
		const langToUse = acceptableLanguages.includes(browserLang) ? browserLang : 'en';
		return firstValueFrom(translate.use(langToUse));
	};
}
